/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, isFunction } from 'lodash';
import { useEffect, useState } from 'react';
import convertToFloatSeparator from 'utils/convertToFloatSeparator';
import { convertToDuration, convertToNumber, convertToPrice } from 'utils/inputConverters';
function convertValue({ input, type }) {
    input = convertToFloatSeparator(input);
    switch (type) {
        case 'text':
            return input;
        case 'number':
            return convertToNumber({ input });
        case 'float':
            return convertToNumber({ input, options: { isFloat: true } });
        case 'price':
            return convertToPrice(input);
        case 'duration':
            return convertToDuration(input);
        default:
            return input;
    }
}
export default function useInput({ initialState, options = { reloadOnStateChange: false, type: 'text', emptyValue: '' } }) {
    const [inputValue, setInputValue] = useState(initialState);
    useEffect(() => {
        if (options.reloadOnStateChange) {
            setInputValue(convertValue({
                input: initialState,
                type: options.type
            }));
        }
    }, [initialState]);
    const setValue = (value, onValueSet) => {
        const convertedValue = isEmpty(value) ? options.emptyValue : convertValue({
            input: value,
            type: options.type,
        });
        if (isFunction(onValueSet))
            onValueSet(convertedValue);
        setInputValue(convertedValue);
    };
    return [inputValue, setValue];
}
